<template>
  <v-card :color="color" rounded="0" variant="flat">
    <slot name="header" />

    <v-card-item :class="fade ? 'fade' : ''">
      <slot>
        <TitleParagraphBlock
          em-class-title="text-light-blue-darken-2 font-weight-medium"
          :value="value"
        />
      </slot>
    </v-card-item>

    <slot name="footer" />
  </v-card>
</template>

<script setup>
defineProps({
  color: {
    default: undefined,
    type: String
  },
  fade: {
    default: false,
    type: Boolean
  },
  value: {
    required: true,
    type: Object
  }
})
</script>

<style scoped>
.fade {
  max-height: 220px;
  -webkit-mask-image: linear-gradient(to bottom, black 50%, transparent 100%);
  mask-image: linear-gradient(to bottom, black 50%, transparent 100%);
}
</style>
